import Theme from "@theme/ok-customer";

import {FnUiIcon, FnUiPanel, FnUiLoader, FnUiIconLayers, FnUiPaginate} from "@fndry-vue/fn-ui";
import {FontAwesomeLayers} from "@fortawesome/vue-fontawesome";

/**
 * Load Images, Assets, Styles and theme files
 */
const styleLoaded = document.createElement("style");
styleLoaded.innerHTML = ".fn-app__view { visibility: visible !important; }";

const url = window.location.href;

if (url.includes('breeze')) {

    import('./scss/breeze-style.scss')
    .then(() => {
        document.head.appendChild(styleLoaded);
        console.log('Breeze SCSS styles loaded');
    })
    .catch((error) => {
        console.error('Error loading Breeze styles:', error);
    });

} else  {

    import('./scss/style.scss')
    .then(() => {
        document.head.appendChild(styleLoaded);
        console.log('Okinus SCSS styles loaded');
    })
    .catch((error) => {
        console.error('Error loading Okinus styles:', error);
    });

}

import "./icons";


const ThemePlugin = {};

ThemePlugin.install = function(Vue){

    Vue.component("loader", FnUiLoader);
    Vue.component("icon", FnUiIcon);
    Vue.component("icon-layers", FontAwesomeLayers);
    Vue.component("panel", FnUiPanel);
    Vue.component("paginate", FnUiPaginate);
    Vue.component("icon-layers", FnUiIconLayers);
    Vue.component("fn-ui-panel", FnUiPanel);

    Vue.use(Theme, {
        fontType: "light"
    });

};

export default ThemePlugin;

